import { render, staticRenderFns } from "./UjoEdit.vue?vue&type=template&id=687dd4ff&scoped=true"
import script from "./UjoEdit.vue?vue&type=script&lang=js"
export * from "./UjoEdit.vue?vue&type=script&lang=js"
import style0 from "./UjoEdit.vue?vue&type=style&index=0&id=687dd4ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687dd4ff",
  null
  
)

export default component.exports